// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__LRctk","topBottomGutter":"Layout_topBottomGutter__3ynON"};